module.exports = __webpack_public_path__ + "static/media/shopify.b627c1da.png";